import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';
import { AxiosResponse } from 'axios';
import { CaracteristiqueArticle } from '@/models/CaracteristiqueArticle';
import { Operation } from '@/models/Operation';
import { EquipementItems } from '@/models/EquipementItems';

class EquipementService {
    public async getEquipement(
        adresseSiteId: number,
        rechercheEquipement: string,
        rechercheGroupe: string,
        rechercheSsGroupe: string,
        sort: string,
        page: string
    ): Promise<any> {
        return http.get(Routes.EquipementRoutes.GetEquipement(adresseSiteId), {
            params: { rechercheEquipement, rechercheGroupe, rechercheSsGroupe, sort, page },
        });
    }

    public async getEquipementBySites(adresseSiteIds: number[], sort: string, page: string): Promise<any> {
        return http.get(Routes.EquipementRoutes.GetEquipementBySites(), {
            params: { adresseSiteIds, sort, page },
        });
    }

    public async getEtatEquipement(): Promise<any> {
        return http.get(Routes.EquipementRoutes.GetEtatEquipement());
    }

    public async getEquipementInterventions(phaseId: number): Promise<any> {
        return http.get(Routes.EquipementRoutes.GetEquipementInterventions(phaseId));
    }

    public async getCaracteristiquesEquipements(phaseId: number): Promise<AxiosResponse<CaracteristiqueArticle[]>> {
        return http.get(Routes.EquipementRoutes.GetCaracteristiquesEquipement(phaseId));
    }

    public async getOperationsMaintenance(phaseId: number): Promise<AxiosResponse<Operation[]>> {
        return http.get(Routes.EquipementRoutes.GetOperationMaintenance(phaseId));
    }
    public async getDetailsEquipement(phaseId: number): Promise<AxiosResponse<EquipementItems>> {
        return http.get(Routes.EquipementRoutes.GetEquipementByPhase(phaseId));
    }
}

export default new EquipementService();
